var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManageUsersIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.81,
    height: 13.781,
    viewBox: "0 0 17.81 13.781",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Manage_users_icon",
    "data-name": "Manage users icon",
    d: "M11.16,14.069a3.985,3.985,0,0,0,1.378-3.016,4.053,4.053,0,0,0-8.107,0A3.985,3.985,0,0,0,5.81,14.069,6.486,6.486,0,0,0,2,19.971a.811.811,0,1,0,1.621,0,4.864,4.864,0,0,1,9.728,0,.811.811,0,1,0,1.621,0A6.486,6.486,0,0,0,11.16,14.069Zm-2.675-.584a2.432,2.432,0,1,1,2.432-2.432A2.434,2.434,0,0,1,8.485,13.485Zm7.9.259A4.054,4.054,0,0,0,13.349,7a.811.811,0,1,0,0,1.621,2.428,2.428,0,0,1,1.216,4.532.814.814,0,0,0-.405.681.805.805,0,0,0,.365.7l.316.211.105.057a5.675,5.675,0,0,1,3.243,5.172.811.811,0,1,0,1.621,0A7.3,7.3,0,0,0,16.381,13.745Z",
    transform: "translate(-2 -7)",
    fill: "#888"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageUsersIcon);
export default __webpack_public_path__ + "static/media/manage-users-icon.7ba17ccc9f0c6a36856bfb30fec1633a.svg";
export { ForwardRef as ReactComponent };